import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import history from '../util/history'
import { Container, PageTitle, PageHeader, Link } from '../components/index'
import { selectIsRequestPending, requireLogin } from '../util/index'

import RequestForm from './request/forms/DynamicForm'

import { selectADUserInfo } from '../auth/reducer'
import { getRequestType, createIssue } from './actions'
import { selectRequestType, selectNewIssueKey } from './reducer'

// TODO update create action to also trigger the issueList on home page to re-fetch its data. 

export class CreateRequestPage extends Component {
  /*
  componentWillMount () {                
    let { getRequestType, requestName } = this.props
    if (requestName) {
      getRequestType(requestName).catch(err => console.error(err))
    }
  } */

  getSystemFieldValues = () => {
    let { requestType, user } = this.props
    return requestType.systemFields.properties.reduce((result, field) => {
      result[field.id] = (field.title === 'Requestor Email') ? user.email :
       (field.title === 'Requestor') ? user.firstName + ' ' + user.lastName :
        field.value       
      return result
    }, {'issuetype': `${requestType.issuetype}`, 'project': `${requestType.project}`})
  }

  submit = (values) => {
    let { createIssue, requestType } = this.props
    let issueData = {...this.getSystemFieldValues(), ...values}
    //console.log(issueData)
    return createIssue(issueData, requestType).catch(err => console.error(err))
  }

  cancel = () => {
    history.push('/')
  }

  render () {
    let {         
      requestType,      
      isCreateNewIssuePending,
      newIssueKey,
    } = this.props
    
    if (!requestType ) return ( <Redirect to={{pathname:'/', state: { from: this.props.location}}} /> )        
    if ( newIssueKey) return <Redirect to={{pathname:`/requests/${newIssueKey}`, state: { from: this.props.location}}} />
    return (
      <div>
        <PageTitle title='Create' />
        <PageHeader title={`Create New ${requestType.title}`} back={<Link to={'/'} className='page-title-back'>&lt; Home</Link>}></PageHeader>
        <Container section>
          <RequestForm RequestType={requestType} isNew={true} onSubmit={this.submit} actionInProgress={isCreateNewIssuePending} cancel={this.cancel} />
        </Container>
      </div>
    )
  }
}

export default compose(
  requireLogin('Create'),
  connect((state) => {
  return {        
    isCreateNewIssuePending: selectIsRequestPending(state, createIssue),
    requestType: selectRequestType(state),    
    user: selectADUserInfo(state),
    newIssueKey: selectNewIssueKey(state)
  }
}, { getRequestType, createIssue, selectNewIssueKey }))(CreateRequestPage)



// WEBPACK FOOTER //
// ./client/src/serviceDesk/CreateRequest.js